export function requestAssetUrl(filename, timeout = 6000) {
    return new Promise((resolve, reject) => {
        const requestId = `req-${Date.now()}-${filename}`;
        const timeoutId = setTimeout(() => {
            reject(new Error('Request timed out'));
        }, timeout);
        function handler(event) {
            if (event?.data?.type === 'resolvedAssetUrl' &&
                event?.data?.requestId === requestId) {
                clearTimeout(timeoutId);
                resolve(event.data.result);
                window.removeEventListener('message', handler);
            }
        }
        window.addEventListener('message', handler, false);
        window.postMessage({ type: 'resolveAssetUrl', filename, requestId }, '*');
    });
}
//# sourceMappingURL=asset-resolver.util.js.map